module.exports = __webpack_public_path__ + "img/hr-straight-rail-diagonal-right-top-ties.a4888caf.png";